import "./ActionTypeStatistic.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useMemo } from "react";
import { useRef } from "react";

import { Box } from "@mui/material";

import ReactECharts from "echarts-for-react";

import { fetchActionType } from "../../slices/transportStatistic";

const mapToPieDataWithOther = (obj = {}, limit = 12) => {
    const safeObj = obj && typeof obj === "object" && !Array.isArray(obj) ? obj : {};

    const entries = Object.entries(safeObj)
        .map(([k, v]) => [k, Number(v) || 0])
        .sort((a, b) => b[1] - a[1]);

    const top = entries.slice(0, limit);
    const other = entries.slice(limit).reduce((s, [, v]) => s + v, 0);

    const result = top.map(([name, value]) => ({ name, value }));
    if (other > 0) result.push({ name: "Остальное", value: other });

    return result;
};

const ActionTypeStatistic = ({ params }) => {
    const dispatch = useDispatch();
    const token = useSelector((s) => s.auth.token?.data?.token || s.auth.token);
    const dataMap = useSelector((s) => s.transportStatistic.actionType);
    const chartRef = useRef(null);

    useEffect(() => {
        dispatch(fetchActionType({ token, params }));
    }, [dispatch, token, params]);

    useEffect(() => {
        const t = setTimeout(() => {
            chartRef.current?.getEchartsInstance().resize();
        }, 120);
        return () => clearTimeout(t);
    }, [dataMap]);

    const pieData = useMemo(() => mapToPieDataWithOther(dataMap, 12), [dataMap]);

    const options = {
        title: { text: "Тип действия", left: "center" },
        tooltip: {
            trigger: "item",
            formatter: ({ name, value, percent }) =>
                `${name}<br/>${value} (${percent}%)`,
        },
        legend: { bottom: 0, type: "scroll" },
        series: [
            {
                name: "Тип действия",
                type: "pie",
                radius: ["40%", "70%"],
                center: ["50%", "45%"],
                avoidLabelOverlap: true,
                itemStyle: {
                    borderRadius: 6,
                    borderColor: "#fff",
                    borderWidth: 2,
                },
                label: { show: false },
                emphasis: {
                    label: { show: true, fontSize: 14, fontWeight: 600 },
                },
                data: pieData,
            },
        ],
    };

    return (
        <Box className="action_type_statistic">
            <ReactECharts
                ref={chartRef}
                option={options}
                style={{ width: "100%", height: "100%" }}
            />
        </Box>
    );
};

export default ActionTypeStatistic;